
<div>
  <panel-block id="pn-label">
    <panel-item>
      <label :for="selectedPropertySection.idForProp('label')">Label</label>
      <expandable-textarea
        :id="selectedPropertySection.idForProp('label')"
        v-model="selectedPropertySection.label_title"
        placeholder="Enter a label..."
      />
    </panel-item>
  </panel-block>
</div>
